import { useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import { LoadingButton } from '@mui/lab';
import { withDataPoint } from '../../../diagnostics/client';
import { clearInsuranceResponses } from '../../../redux/helpers/assessment';
import { useAppDispatch } from '../../../pages/assessment';

const UndoInsuranceTermination = () => {
  const { addToast } = useToasts();
  const dispatch = useAppDispatch();
  const [disabled, setDisabled] = useState(false);

  const returnToInsurance = async () => {
    setDisabled(true);
    await withDataPoint('undo_insurance_response', async dp => {
      const errors = await clearInsuranceResponses();
      if (errors) {
        dp.error = true;
        return addToast('Sorry, something went wrong. Please try again.', {
          appearance: 'error',
        });
      }
      dispatch(UndoActionCreators.undo());
      dp.user_success = true;
    });
    setDisabled(false);
  };

  return (
    <LoadingButton
      size="large"
      variant="contained"
      fullWidth
      onClick={returnToInsurance}
      disabled={disabled}
      loading={disabled}
    >
      Return to insurance
    </LoadingButton>
  );
};

export default UndoInsuranceTermination;
